import { render, staticRenderFns } from "./RegStep2.vue?vue&type=template&id=290d6164&scoped=true"
import script from "./RegStep2.vue?vue&type=script&lang=js"
export * from "./RegStep2.vue?vue&type=script&lang=js"
import style0 from "./RegStep2.vue?vue&type=style&index=0&id=290d6164&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290d6164",
  null
  
)

export default component.exports